import React, { createContext, useState, ReactNode, useEffect } from "react";
import { getUser } from "../services/users";
import { User } from "../models/user.types";

type UserContextType = {
  user: User | null;
  isLoading: boolean;
  error: Error | null;
  loadUser: () => Promise<void>;
};

const initialState: UserContextType = {
  user: null,
  isLoading: false,
  error: null,
  loadUser: async () => {},
};

export const UserContext = createContext<UserContextType>(initialState);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const loadUser = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const userData = await getUser();
      setUser(userData);
    } catch (err) {
      console.error("Error fetching user:", err);
      setError(err instanceof Error ? err : new Error("Failed to load user"));
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, isLoading, error, loadUser }}>
      {children}
    </UserContext.Provider>
  );
};
